module.exports = __webpack_public_path__ + "img/logo-um-epf.5cf876d6.png";